var _construct = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/construct");

// Redshift
// -------
var inherits = require('inherits');

var Client_PG = require('../postgres');

var _require = require('lodash'),
    map = _require.map;

var Transaction = require('./transaction');

var QueryCompiler = require('./query/compiler');

var ColumnBuilder = require('./schema/columnbuilder');

var ColumnCompiler = require('./schema/columncompiler');

var TableCompiler = require('./schema/tablecompiler');

var SchemaCompiler = require('./schema/compiler');

function Client_Redshift(config) {
  Client_PG.apply(this, arguments);
}

inherits(Client_Redshift, Client_PG);
Object.assign(Client_Redshift.prototype, {
  transaction: function transaction() {
    return _construct(Transaction, [this].concat(Array.prototype.slice.call(arguments)));
  },
  queryCompiler: function queryCompiler() {
    return _construct(QueryCompiler, [this].concat(Array.prototype.slice.call(arguments)));
  },
  columnBuilder: function columnBuilder() {
    return _construct(ColumnBuilder, [this].concat(Array.prototype.slice.call(arguments)));
  },
  columnCompiler: function columnCompiler() {
    return _construct(ColumnCompiler, [this].concat(Array.prototype.slice.call(arguments)));
  },
  tableCompiler: function tableCompiler() {
    return _construct(TableCompiler, [this].concat(Array.prototype.slice.call(arguments)));
  },
  schemaCompiler: function schemaCompiler() {
    return _construct(SchemaCompiler, [this].concat(Array.prototype.slice.call(arguments)));
  },
  dialect: 'redshift',
  driverName: 'pg-redshift',
  _driver: function _driver() {
    return require('pg');
  },
  // Ensures the response is returned in the same format as other clients.
  processResponse: function processResponse(obj, runner) {
    var resp = obj.response;
    if (obj.output) return obj.output.call(runner, resp);
    if (obj.method === 'raw') return resp;

    if (resp.command === 'SELECT') {
      if (obj.method === 'first') return resp.rows[0];
      if (obj.method === 'pluck') return map(resp.rows, obj.pluck);
      return resp.rows;
    }

    if (resp.command === 'INSERT' || resp.command === 'UPDATE' || resp.command === 'DELETE') {
      return resp.rowCount;
    }

    return resp;
  }
});
module.exports = Client_Redshift;